export default __webpack_public_path__ + "static/media/line.a84f58dc.svg";